import { compareWithThreshold } from 'utils/date/compareWithThreshold';

export const getSchoolYearStart = (date: Date, threshold: string) => {
  return compareWithThreshold(date, threshold) > -1 ? date.getFullYear() : date.getFullYear() - 1;
};
